export default __webpack_public_path__ + "static/media/illustration_2.37607aca.png";